// extracted by mini-css-extract-plugin
export default {"departments":"wG-z","departmentHeading":"xG-z","departmentSection":"yG-z","departmentName":"zG-z","departmentLink":"AG-z","expandIcon":"BG-z"};